import { Digtective } from '..';

export function updateSession(facade: Digtective, input: any) {
  const { storage, options } = facade ?? {};
  const { sessionName } = options ?? {};
  const session = facade.getSession();
  if (!session) return;
  storage?.setItem(sessionName, JSON.stringify({ ...session, ...input }));
}
